// eslint-disable-next-line no-unused-vars
import React, {useCallback, useMemo} from "react";
import "./index.scss";
import {LoggedInLayout} from "features/layouts/pages/logged-in";
import {connect} from "react-redux";
import UserProfile from "features/components/user-profile";
import {LoadingLogoPortal} from "features/components/loading-logo";
import {Redirect} from "react-router";
import Title from "features/components/title";
import Text from "features/components/text";
import {__} from "services/i18n";
import {get} from "lodash";
import {COMPANY_ROLES, MOBILE_MEDIA_QUERY_THRESHOLD, SUBSCRIPTIONS_DETAIL} from "constants.js";
import {getPrivateProfileStart} from "features/pages/single-people/reducer";
import {
    privateProfileData,
    privateProfileErrorSelector,
    privateProfileLoading
} from "features/pages/single-people/selectors";
import {FavoriteButton} from "features/components/favorite-btn";
import {favoritePeopleStart} from "store/reducer/people/favorite/reducer";
import PrivateProfileRecommendation from "features/pages/single-people/recommendation";
import SendMessageModal from "features/modals/send-message";
import {sendMessageShowModal} from "features/modals/send-message/selectors";
import {startPeopleHighlightGet} from "features/pages/people/highlights/reducer";
import {peopleHighlightData} from "features/pages/people/highlights/selectors";
import {ReportAProblemButton} from "features/components/problem-button";
import {Icon} from "features/components/icon";
import {historyObject} from "historyObject";
import {generateFullUrl, useMediaQuery} from "services/utils/utils";

/* istanbul ignore next */
const mapStateToProps = state => ({
    loading: privateProfileLoading(state),
    error: privateProfileErrorSelector(state),
    data: privateProfileData(state),
    showSendMessage: sendMessageShowModal(state),
    highlights: peopleHighlightData(state),
});
/* istanbul ignore next */
const mapDispatchToProps = {
    getPrivateProfileStart,
    favoritePeopleStart,
    startPeopleHighlightGet
};


export const SinglePeoplePage = (props) => {

    const {getPrivateProfileStart, favoritePeopleStart, startPeopleHighlightGet} = props;
    const {loading, error, data, showSendMessage, highlights} = props;

    React.useEffect(() => {
        getPrivateProfileStart({slug: props.match.params.slug});
    }, [getPrivateProfileStart, props.match.params.slug]);
    React.useEffect(() => {
        startPeopleHighlightGet();
    }, [startPeopleHighlightGet]);

    const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY_THRESHOLD);

    const toggleFavorite = useCallback((event) => {
        favoritePeopleStart({id: data.profile.id, favorite: !data.profile.favorite, type: "user"});
        event.preventDefault();
        event.stopPropagation();
    }, [data, favoritePeopleStart]);

    const breadcrumbTitle = useMemo(() => {
        return "single-people.breadcrumb"
    }, []);

    const renderHighlights = useMemo(() => {
        if(highlights.profiles.length === 0) return null;
        return <>
            <Title size={20} align={"center"}>{__("single-people.other-highlights")}</Title>
        {highlights.profiles.map(i => <div onClick={() => historyObject.push(`/people/${i.user_slug}`)} key={i.name} className="user">
            {!!i.avatar ? <img src={i.avatar} alt="avatar"/> : <div className="default"><Icon>account-circle</Icon></div>}
            <div className="name">
                <Title size={18}>{i.name}</Title>
                <Text size={14}>{i.text}</Text>
            </div>
        </div>)}
        </>
    }, [highlights]);

    const renderProfileType = useMemo(() => {
        if(!data) return null;
        return <div className={"profile-type-favorite"}>
            <div>
                <Text size={16}>{__("private-profile.profile-type", [{key: "[name]", value: data.profile.firstName}])}</Text>
                <Text size={16}>{get(SUBSCRIPTIONS_DETAIL[data.profile.sub_type], 'name', 'Cerchia degli Audaci')}</Text>
            </div>
            <FavoriteButton favorite={data.profile.favorite} toggleFavorite={toggleFavorite} />
        </div>
    }, [data, toggleFavorite]);

    if(loading || !data) {
        return <LoadingLogoPortal />
    }
    if (error.inError) {
        return <Redirect to={"/not-found"} />
    }
    return <LoggedInLayout
        type={"light"}
        className={"single-people-page"}
        breadcrumbs={[{title: "common.home-breadcrumb", link:"/"}, {title: "menu.people", link: "/events"}, {title: breadcrumbTitle}]}>
        <div className="user-header">
            <div className={"left"}>
                <div className={`image ${!!data.profile.image ? "has-image" : ""}`}>
                    {!!data.profile.image && <img src={generateFullUrl(data.profile.image)} alt={"logo"}/>}
                </div>
            </div>
            <div className={"right"}>
                <div className={"user-name"}>
                    <Title size={48}>{data.profile.firstName} {data.profile.lastName}</Title>
                    {data.companies.length > 0 &&<Text size={18}>{__(get(COMPANY_ROLES.find(i => i.key === data.companies[0].role), 'value', data.companies[0].role))} {__("common.at")} {data.companies[0].name}</Text>}
                </div>
            </div>
        </div>
        <div className={"sidebar-wrapper"}>
            <div className={"content"}>
                {isMobile && renderProfileType}
                <UserProfile data={data} openOnCompanyId={props.match.params.company_id} enableConfirmation={true} />
            </div>
            <div className={"sidebar"}>
                {!isMobile && renderProfileType}
                <PrivateProfileRecommendation slug={props.match.params.slug} user_id={data.profile.id} name={data.profile.firstName} />
                {renderHighlights}
                <ReportAProblemButton />
            </div>
        </div>
        {!!showSendMessage && <SendMessageModal/>}
    </LoggedInLayout>
}

export default connect(mapStateToProps, mapDispatchToProps)(SinglePeoplePage);